import { useEffect, useState, useMemo, useRef, useCallback } from "react";
import _, { difference } from "lodash";
import ButtonControl from "../../../../components/controls/ButtonControl";
import certImg from "../../certificationimg.png";
import certImg2 from "../../certificationimg2.png";
import rubricIcon from "../../../../content/icons/grading.svg";
import checkmark from "../../../../content/icons/Vector.svg";
import failIcon from "../../../../content/icons/Close.svg";
import videoIcon from "../../../../content/icons/Video.svg";
import documentIcon from "../../../../content/icons/document.png";
import announcementIcon from "../../../../content/icons/Announcement.svg";
import SurveyTable from "../../../admin/components/observation/SurveyTable";
import {
  faEllipsisVertical,
  faPrint,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Loading from "../../../../components/Loading";
import { DialogControl } from "../../../../components/controls/DialogControl";
import moment from "moment";
import RubricPrintScreen from "../../../observations/components/RubricPrintScreen";
// import { useNavigate } from "react-router-dom";
import { useNavigate } from "../../../../components/Navigate";
import { useAppUserManager } from "../../../../hooks/useManagers";
import BitmovinPlayer from "../../../contentLibrary/app-components/Content/Player/BitmovinPlayer";
import ReactQuill from "react-quill";
import { FloatingPdfFileViewer } from "../../../contentLibrary/app-components/Content/Resource/PdfFileViewer";
import CertificationProgress from "../CertificationProgress";

const getInitialPhase = (data) => {
  if (data?.Status === 1 && data?.CurrentVideoTimeStamp && data?.CurrentVideoTimeStamp !== "FINISHED") {
    return 3;
  }
  if (data?.Status === 1 && data?.CurrentVideoTimeStamp === "FINISHED") {
    return 3;
  }
  return 1;
};

const teacherCertificationSteps = [
  { id: "introduction", label: "Introduction" },
  { id: "observe", label: "Observe a Lesson" },
  { id: "rate", label: "Rate the Lesson" },
  { id: "part-one-result", label: "Part I Result" },
  { id: "questions", label: "Part II Questions" },
  { id: "final-result", label: "Final Result" },
];

const teacherPhaseToStep = {
  1: "introduction",
  2: "observe",
  3: "observe",
  4: "rate",
  5: "part-one-result",
  6: "questions",
  7: "questions",
  8: "questions",
  9: "final-result",
};

const CertificationTeacherDetails = ({
  certificationTeacherMgr,
  handleOpenPrint,
  observationConfig,
  certificationHistory,
  setCertificationHistory,
  certificationRatingMgr,
  loadingRubric,
  data,
  createNewCertificate,
  gridData,
  ratingSelectOptions,
  setRatingSelectOptions,
  saveCertification,
  updateUserPermissions,
  setErrors,
}) => {
  //Revist why app user mgr is here
  const appUserMgr = useAppUserManager();
  const appUserStateItem = appUserMgr?.AppUserState;
  const [openRubricDialog, setOpenRubricDialog] = useState(false);
  const [certificationData, setCertificationData] = useState(data);
  const [currentPhase, setCurrentPhase] = useState(() => getInitialPhase(data));
  const [questions, setQuestions] = useState(null);
  const [currentQuestion, setCurrentQuestion] = useState(null);
  const [printing, setPrinting] = useState(false);
  const [isSnappedLeft, setIsSnappedLeft] = useState(true);
  const [isSnappedRight, setIsSnappedRight] = useState(false);
  const [leftWidth, setLeftWidth] = useState(40);
  const [indicatorsRated, setIndicatorsRated] = useState(null);
  const [answerVideo, setAnswerVideo] = useState(null);
  const [openAnswerFileDialog, setOpenAnswerFileDialog] = useState(false);
  const [watchedRubricVideo, setWatchedRubricVideo] = useState(false);
  const [watchedQuestionVideo, setWatchedQuestionVideo] = useState(false);
  const [saving, setSaving] = useState(false);
  const [useBitmovinPlayer, setUseBitmovinPlayer] = useState(true);
  const [currentTime, setCurrentTime] = useState(null);
  const [openPdfViewer, setOpenPdfViewer] = useState(false);
  const bitmovinPlayerRef = useRef(null);
  const questionPlayerRef = useRef(null);
  const answerGroupRef = useRef(null);
  const focusNextQuestionRef = useRef(false);
  const navigate = useNavigate();
  const FIXED_ROW_WIDTH = "9rem";

  useEffect(() => {
    if (!focusNextQuestionRef.current || !currentQuestion?.Id) return undefined;
    const focusTimer = window.setTimeout(() => {
      const firstEnabledOption = answerGroupRef.current?.querySelector('input[type="radio"]:not(:disabled)');
      (firstEnabledOption ?? answerGroupRef.current)?.focus();
      focusNextQuestionRef.current = false;
    }, 0);
    return () => window.clearTimeout(focusTimer);
  }, [currentQuestion?.Id]);

  // Force cleanup all Bitmovin players on unmount
  useEffect(() => {
    return () => {
      // Force immediate destruction of all players to prevent memory leaks
      if (bitmovinPlayerRef.current) {
        try {
          const player = bitmovinPlayerRef.current.getPlayer();
          if (player) {
            player.destroy();
            console.log('Player force destroyed on unmount');
          }
        } catch (error) {
          console.warn('Force player destruction on unmount:', error.message);
        } finally {
          // Clear the ref immediately
          bitmovinPlayerRef.current = null;
        }
      }
    };
  }, []);
  useEffect(() => {
    if (ratingSelectOptions) {
      let ir = Object.keys(ratingSelectOptions).reduce((r, cv) => {
        if (ratingSelectOptions[cv].selectedRating) {
          r++;
        }
        return r;
      }, 0);
      setIndicatorsRated(ir);
    }
  }, [ratingSelectOptions]);

  useEffect(() => {
    if (data.CurrentVideoTimeStamp === "FINISHED") {
      setWatchedRubricVideo(true);
    }
    if (
      data.Status !== 1 &&
      data.Status !== 0 &&
      data.Status !== 3 &&
      !data.CompletedDate &&
      currentPhase !== 7
    ) {
      setCurrentPhase(6);
    }
  }, [data]);

  const grabCurrentOrNextQuestion = (certificationQuestions) => {
    const questionNumber = _.findIndex(
      certificationQuestions
        ? certificationQuestions
        : certificationData.Questions,
      (x) =>
        currentQuestion
          ? currentQuestion.Id !== x.Id && x.SelectedAnswer === null
          : x.SelectedAnswer === null
    );
    if (questionNumber !== -1) {
      const question = _.find(
        certificationQuestions
          ? certificationQuestions
          : certificationData.Questions,
        (x) =>
          currentQuestion !== null
            ? currentQuestion.Id !== x.Id && x.SelectedAnswer === null
            : x.SelectedAnswer === null
      );
      const moveToBottomAnswerIndex = _.findIndex(
        question.CertificationQuestion.Answers,
        (x) => x.MoveToBottom === true
      );
      if (moveToBottomAnswerIndex !== -1) {
        const answer = question.CertificationQuestion.Answers.splice(
          moveToBottomAnswerIndex,
          1
        )[0];
        question.CertificationQuestion.Answers.push(answer);
      }
      const questionObj = {
        QuestionText: question.CertificationQuestion.QuestionText,
        Answers: question.CertificationQuestion.Answers,
        CertificationId: question.CertificationQuestion.CertificationId,
        SchoolYearIdentifier:
          question.CertificationQuestion.SchoolYearIdentifier,
        SelectedAnswer: null,
        Id: question.Id,
        File: question.CertificationQuestion.File,
        FileUrl: question.CertificationQuestion.File?.FileUrl,
        hasFile: question.CertificationQuestion.File && true,
        number: questionNumber + 1,
      };
      setCurrentQuestion(questionObj);
    }
  };

  const updateQuestionAnswer = (value) => {
    const updateCurrentQuestion = { ...currentQuestion };
    updateCurrentQuestion.SelectedAnswer = value;
    setCurrentQuestion(updateCurrentQuestion);
  };

  const saveQuestion = async () => {
    setSaving(true);
    const updateQuestions = [...questions];
    const questionToUpdate = _.find(
      updateQuestions,
      (x) => x.Id === currentQuestion.Id
    );
    const questionIndex = _.findIndex(
      updateQuestions,
      (x) => x.Id === currentQuestion.Id
    );
    questionToUpdate.SelectedAnswer = currentQuestion.SelectedAnswer;
    questionToUpdate.QuestionText = currentQuestion.QuestionText;
    questionToUpdate.SelectedAnswerText = _.find(
      currentQuestion.Answers,
      (x) => x.Id === currentQuestion.SelectedAnswer
    )?.AnswerText;
    questionToUpdate.IsCorrect =
      currentQuestion.SelectedAnswer ===
      _.find(currentQuestion.Answers, (x) => x.IsCorrect)?.Id;

    updateQuestions.splice(questionIndex, 1, questionToUpdate);
    setQuestions(updateQuestions);

    let result = await certificationTeacherMgr
      .saveCertificationQuestion(questionToUpdate)
      .then((r) => {
        setSaving(false);
        return true;
      });
    return result;
  };

  const updateCertification = useCallback(async (action, currentTimeStamp) => {
    setSaving(true);
    const spreadData = { ...certificationData };
    if (action === "FinishedRubricVideo") {
      if (certificationData.CurrentVideoTimeStamp !== "FINISHED") {
        spreadData.CurrentVideoTimeStamp = "FINISHED";
        setWatchedRubricVideo(true);
      }
    } else if (action === "NextBtnRubric") {
      spreadData.Status = 1;
      setWatchedQuestionVideo(false);
    } else if (action === "FinishRubricRatings") {
      //How many to pass?
      const didPass = await tallyRubricScore();
      if (didPass) {
        //Pass Part 1
        spreadData.Status = 2;
        spreadData.CompletedDatePart1 = moment().utc().toISOString();
        spreadData.UserPosition = spreadData.User.UserPositionType;
      } else {
        //Fail Part 1
        let failedCertResult =
          await certificationTeacherMgr.handleCertificationFailed(
            3,
            spreadData.Id
          );
        const copiedCert = { ...failedCertResult.Items.first() };
        copiedCert.RetakeCountPart1 = spreadData.RetakeCountPart1;
        setCertificationData(copiedCert);
        setSaving(false);
        return failedCertResult;
      }
    } else if (action === "BeginPart2") {
      if (spreadData.Status !== 4) {
        spreadData.Status = 4;
        spreadData.CompletedDate = null;
      }
    } else if (action === "FinishQuestions") {
      if (
        _.countBy(questions, "IsCorrect")?.true >=
        observationConfig?.NumberToPassTeacherCert
      ) {
        spreadData.Status = 5;
        spreadData.UserPosition = spreadData.User.UserPositionType;
        spreadData.DistrictId = spreadData.DistrictIds?.first();
        spreadData.SchoolId = spreadData.SchoolIds?.first();
        spreadData.CompletedDate = moment().utc().toISOString();
        if (
          !(
            appUserMgr.canView("CertificationTraining") ||
            appUserMgr.canExecute("CertificationTraining")
          )
        ) {
          await certificationTeacherMgr.certificatePassed(spreadData.UserId);
        }
      } else {
        //failure
        let failedCertResult =
          await certificationTeacherMgr.handleCertificationFailed(
            6,
            spreadData.Id
          );
        const copiedCert = { ...failedCertResult.Items.first() };
        copiedCert.RetakeCount = spreadData.RetakeCount;
        setCertificationData(copiedCert);
        setSaving(false);
        return failedCertResult;
      }
    } else if (action === "UpdateRubricVideoTimeStamp") {
      spreadData.CurrentVideoTimeStamp = currentTimeStamp;
    }

    setCertificationData(spreadData);
    let result = await saveCertification(spreadData).then(() => {
      setSaving(false);
    });
    return result;
  }, [certificationData, questions, observationConfig, appUserMgr, certificationTeacherMgr, saveCertification]);

  useEffect(() => {
    if (currentPhase !== 3) return;
    const intervalId = setInterval(() => {
      if (!bitmovinPlayerRef.current) return;
      if (!bitmovinPlayerRef.current.getPlayer()?.isPlaying()) return;
      const time = bitmovinPlayerRef.current.getCurrentTime();
      if (
        time > 0 &&
        certificationData.CurrentVideoTimeStamp !== "FINISHED" &&
        !saving
      ) {
        updateCertification("UpdateRubricVideoTimeStamp", time);
      }
    }, 10000);
    return () => clearInterval(intervalId);
  }, [currentPhase, certificationData.CurrentVideoTimeStamp, saving, updateCertification]);

  const tallyRubricScore = async () => {
    return await certificationRatingMgr
      .grabCertificationRatingsKey(
        certificationData?.RubricId,
        certificationData?.ContentId
      )
      .then((r) => {
        const compareRatingArray = _.map(
          ratingSelectOptions,
          (ratingSelectOption) => {
            const selectedRating = parseInt(ratingSelectOption.selectedRating);
            const correctRating = _.find(
              r.Rubric.RubricIndicatorRatings,
              (x) =>
                x.SelectedRating &&
                x.RubricIndicatorId === ratingSelectOption.rubricIndicatorId
            )?.Rating;
            return {
              selectedRating: selectedRating,
              correctRating: correctRating,
              differenceInRating: Math.abs(selectedRating - correctRating),
            };
          }
        );
        const differencesCounted = _.countBy(
          compareRatingArray,
          "differenceInRating"
        );
        if (compareRatingArray.some((x) => !x.correctRating)) {
          setErrors(["Rubric has no correct ratings set up yet."]);
        } else if (compareRatingArray.some((x) => x.differenceInRating >= 4)) {
          return false;
        } else if (
          differencesCounted[2] >
            observationConfig.CertificationRatingOffBy2Teacher ||
          differencesCounted[3] >
            observationConfig.CertificationRatingOffBy3Teacher
        ) {
          return false;
        } else return true;
      });
  };

  const checkIsVideo = (fileUrl) => {
    return (
      fileUrl?.toLowerCase()?.includes(".mpeg") ||
      fileUrl?.toLowerCase()?.includes(".mpg") ||
      fileUrl?.toLowerCase()?.includes(".mpga") ||
      fileUrl?.toLowerCase()?.includes(".avi") ||
      fileUrl?.toLowerCase()?.includes(".mp4") ||
      fileUrl?.toLowerCase()?.includes("streaming.media.azure.net")
    );
  };
  function handleNextPhase() {
    setCurrentPhase(currentPhase + 1);
  }

  const selectRating = (indicator, rating) => {
    let ratingSelectOpts = { ...ratingSelectOptions };
    ratingSelectOpts[indicator].isExpanded =
      !ratingSelectOpts[indicator].isExpanded;
    ratingSelectOpts[indicator].selectedRating = rating;

    let certificationRatingAnswers = {
      RubricId: certificationData.RubricId,
      CertificationId: certificationData.Id,
      RubricRatingId: gridData.metaData.reduce((r, cv) => {
        if (cv.rating == rating) {
          r = cv.rubricRatingId;
        }
        return r;
      }, null),
      RubricIndicatorId: ratingSelectOpts[indicator].rubricIndicatorId,
    };
    if (ratingSelectOpts[indicator].surveyRatingId) {
      certificationRatingAnswers.CertificationRubricRatingId =
        ratingSelectOpts[indicator].surveyRatingId;
      certificationRatingAnswers.Id =
        ratingSelectOpts[indicator].surveyRatingId;
    }

    certificationTeacherMgr
      .saveCertificationRubricRating(certificationRatingAnswers)
      .then((res) => {
        if (res) {
          if (res?.Items?.first()) {
            let item = res.Items.first();
            ratingSelectOpts[indicator].surveyRatingId = item.Id;
          }
        }
      });
    setRatingSelectOptions(ratingSelectOpts);
  };

  const toggleRatingOptions = (indicator) => {
    let ratingSelectOpts = { ...ratingSelectOptions };
    if (ratingSelectOpts[indicator]) {
      ratingSelectOpts[indicator].isExpanded =
        !ratingSelectOpts[indicator]?.isExpanded;
      setRatingSelectOptions(ratingSelectOpts);
    }
  };

  const SPLIT_MIN_PERCENT = 20;
  const SPLIT_MAX_PERCENT = 80;
  const SPLIT_STEP_PERCENT = 5;

  const getSplitViewValue = () =>
    isSnappedLeft ? 40 : isSnappedRight ? SPLIT_MAX_PERCENT : leftWidth;

  const applySplitViewValue = (isLeft, isRight, width) => {
    setIsSnappedLeft(isLeft);
    setIsSnappedRight(isRight);
    setLeftWidth(width);
  };

  const mouseDownHandler = (mouseDownEvent) => {
    const snapshot = { isSnappedLeft, isSnappedRight, leftWidth };

    function onMouseMove(mouseMoveEvent) {
      if (isSnappedLeft) {
        setLeftWidth(40);
        setIsSnappedLeft(false);
      } else if (isSnappedRight) {
        setLeftWidth(100);
        setIsSnappedRight(false);
      }
      setLeftWidth(
        Math.min(
          SPLIT_MAX_PERCENT,
          Math.max(
            SPLIT_MIN_PERCENT,
            100 * (mouseMoveEvent.pageX / document.body.clientWidth)
          )
        )
      );
    }

    function onKeyDownDuringDrag(keyDownEvent) {
      if (keyDownEvent.key === "Escape") {
        keyDownEvent.preventDefault();
        cleanup();
        applySplitViewValue(
          snapshot.isSnappedLeft,
          snapshot.isSnappedRight,
          snapshot.leftWidth
        );
      }
    }

    function cleanup() {
      document.body.removeEventListener("mousemove", onMouseMove);
      document.body.removeEventListener("mouseup", onMouseUp);
      document.removeEventListener("keydown", onKeyDownDuringDrag);
    }

    function onMouseUp() {
      cleanup();
    }

    document.body.addEventListener("mousemove", onMouseMove);
    document.body.addEventListener("mouseup", onMouseUp, { once: true });
    document.addEventListener("keydown", onKeyDownDuringDrag);
  };

  const separatorSnapshotRef = useRef(null);

  const handleSeparatorFocus = () => {
    separatorSnapshotRef.current = { isSnappedLeft, isSnappedRight, leftWidth };
  };

  const handleSeparatorKeyDown = (event) => {
    const currentValue = getSplitViewValue();
    switch (event.key) {
      case "ArrowLeft":
      case "ArrowDown": {
        event.preventDefault();
        applySplitViewValue(
          false,
          false,
          Math.max(SPLIT_MIN_PERCENT, currentValue - SPLIT_STEP_PERCENT)
        );
        break;
      }
      case "ArrowRight":
      case "ArrowUp": {
        event.preventDefault();
        applySplitViewValue(
          false,
          false,
          Math.min(SPLIT_MAX_PERCENT, currentValue + SPLIT_STEP_PERCENT)
        );
        break;
      }
      case "Home": {
        // Named preset: minimum video panel (rubric-priority layout).
        event.preventDefault();
        applySplitViewValue(false, false, SPLIT_MIN_PERCENT);
        break;
      }
      case "End": {
        // Named preset: maximum video panel (video-priority layout).
        event.preventDefault();
        applySplitViewValue(false, true, SPLIT_MIN_PERCENT);
        break;
      }
      case "Escape": {
        event.preventDefault();
        if (separatorSnapshotRef.current) {
          const snapshot = separatorSnapshotRef.current;
          applySplitViewValue(
            snapshot.isSnappedLeft,
            snapshot.isSnappedRight,
            snapshot.leftWidth
          );
        }
        break;
      }
      default:
        break;
    }
  };
  const handleOnPrintReport = async () => {
    setPrinting(true);
  };

  const printCompleted = () => {
    setPrinting(false);
  };

  const renderRubricModal = () => {
    return (
      <>
        {printing === true && (
          <RubricPrintScreen
            rubricData={gridData}
            handlePrintCompleted={printCompleted}
          />
        )}
        <DialogControl
          title={`${gridData?.rubricName ?? "Certification"} Rubric`}
          openDialog={openRubricDialog}
          onCancel={() => setOpenRubricDialog(false)}
          hideButtonRow={true}
          className="certification-rubric-dialog"
          headerActions={
            <button
              type="button"
              className="rubric-print-button"
              aria-label="Print rubric"
              aria-busy={printing === true}
              disabled={!!printing}
              onClick={() => handleOnPrintReport(true)}
            >
              {printing === true ? (
                <span aria-hidden="true">
                  <Loading type="default" size="1rem" />
                </span>
              ) : (
                <FontAwesomeIcon icon={faPrint} aria-hidden="true" />
              )}
            </button>
          }
        >
          <div
            className="rubric-section"
            role="region"
            aria-label="Certification rubric table"
            tabIndex={0}
          >
            {loadingRubric ? (
              <Loading type="default" size="5rem" />
            ) : (
              <SurveyTable
                isSelfReflection={true}
                disableActOfRating={true}
                gridData={gridData}
                fixedRowWidth={FIXED_ROW_WIDTH}
                hideRatingBtn={true}
                hideIndicatorsProgress={true}
              />
            )}
          </div>
        </DialogControl>
      </>
    );
  };
  const userCantRetake = (part) => {
    const differenceInDate =
      new Date() -
      new Date(moment.utc(certificationData.CompletedDate).local());
    const differenceInDays = differenceInDate / (1000 * 60 * 60 * 24);
    if (
      differenceInDays < observationConfig?.DaysUntillRetryTeacherCert ||
      (part === 2 &&
        certificationData.RetakeCount + 1 >=
          observationConfig?.CertificationRetryAttemptsTeacher) ||
      (part === 1 &&
        certificationData.RetakeCountPart1 + 1 >=
          observationConfig?.CertificationRetryAttemptsTeacherPart1)
    ) {
      return true;
    }
  };
  const handleRetake = async (part) => {
    setSaving(true);
    const throwAwayCert = { ...certificationData };
    throwAwayCert.IsActive = false;
    await saveCertification(throwAwayCert).then(() => {
      certificationTeacherMgr
        .getSingleCertificationWithUserId(certificationData.UserId)
        .then((newCertResult) => {
          const newCertObject = newCertResult.Items.first();
          if (part === 2) {
            newCertObject.Status = 4;
          }
          createNewCertificate(newCertObject, true).then((r) => {
            setWatchedRubricVideo(false);
            setSaving(false);
            setCertificationData(r);
            if (part === 2) {
              grabCurrentOrNextQuestion(r.Questions);
              setQuestions(r.Questions);
              setCurrentPhase(7);
            } else handleNextPhase();
          });
        });
    });
  };
  const renderPhaseOne = () => {
    return (
      <div className="certification">
        <h1>ONLINE CERTIFICATION</h1>
        <div className="certification-content">
          <div className="certification-para-wrapper">
            <p className="certification-para">
              Welcome to Evaluator Certification. To become certified to perform
              Teacher Evaluations, please complete this two-step process.
            </p>
            <p className="certification-para">
              1. View and evaluate a teacher lesson.
              <br />
              2. Answer 8 questions regarding the Post-Conference.
            </p>
            <p className="certification-para">
              After you click BEGIN, do NOT use your browser's back arrow
              button. For assistance with the Online Certification Process,
              please click{" "}
              <a
                target="_blank"
                href="/downloads/Teacher Evaluator Certification User Guide_12.4.25.pdf"
              >
                Online Certification User Guide
              </a>
              .
            </p>
          </div>
          <figure className="certification-image-wrapper">
            <img src={certImg} alt="certImg" className="certification-image" />
          </figure>
        </div>
        <div className="certification-double-column">
          <div className="double-column-left">
            <h2>
              {certificationData?.SchoolYearIdentifier - 1}-
              {certificationData?.SchoolYearIdentifier} School Year
            </h2>
            <div className="row-header">
              <div className="col">Step</div>
              <div className="col">Description</div>
              <div className="col">Status</div>
              <div className="col">
                {certificationData?.Status !== 5 && "Action"}
              </div>
            </div>
            <div className="row">
              <div className="col">1</div>
              <div className="col">View Lesson</div>
              <div className="col">
                {certificationData.Status === 1
                  ? "In Progress"
                  : certificationData.Status === 0
                  ? "No Attempt"
                  : certificationData.Status === 2 ||
                    certificationData.Status >= 4
                  ? "Passed"
                  : certificationData.RetakeCountPart1 + 1 >=
                    observationConfig?.CertificationRetryAttemptsTeacherPart1
                  ? "Max Attempts"
                  : "Failed"}
              </div>
              <div className="col">
                {certificationData.SchoolYearIdentifier ===
                  appUserStateItem?.currentSchoolYear &&
                (certificationData.Status === 1 ||
                  certificationData.Status === 0) ? (
                  <ButtonControl
                    type={"okay"}
                    className="certification-step-action"
                    loading={saving}
                    onClick={async () => {
                      if (_.isNil(certificationData.Questions)) {
                        setSaving(true);
                        await createNewCertificate(null, true).then((r) =>
                          setCertificationData(r)
                        );
                        setSaving(false);
                      }
                      if (
                        certificationData.Status === 1 &&
                        certificationData.CurrentVideoTimeStamp === "FINISHED"
                      ) {
                        setCurrentPhase(4);
                      } else if (certificationData.CurrentVideoTimeStamp) {
                        setCurrentPhase(3);
                      } else handleNextPhase();
                    }}
                    disabled={
                      !appUserMgr?.canWrite("Certification") ||
                      ((!observationConfig || userCantRetake(1)) &&
                        certificationData.Status === 3)
                    }
                  >
                    {certificationData.Status === 1 ? "Continue" : "Begin"}
                  </ButtonControl>
                ) : (
                  certificationData.Status === 3 && (
                    <ButtonControl
                      type={"okay"}
                      loading={saving}
                      onClick={async () => {
                        await handleRetake();
                      }}
                      disabled={
                        !appUserMgr?.canWrite("Certification") ||
                        ((!observationConfig || userCantRetake(1)) &&
                          certificationData.Status === 3)
                      }
                    >
                      {certificationData.RetakeCountPart1 + 1 >=
                      observationConfig?.CertificationRetryAttemptsTeacherPart1
                        ? "Locked"
                        : "Retake"}
                    </ButtonControl>
                  )
                )}
              </div>
            </div>
            <div className="row">
              <div className="col">2</div>
              <div className="col">Post Conference</div>
              <div className="col">
                {certificationData.Status === 4
                  ? "In Progress"
                  : certificationData.Status === 5 ||
                    certificationData.Status == 9
                  ? "Passed"
                  : certificationData.Status !== 6
                  ? "No Attempt"
                  : certificationData.RetakeCount + 1 >=
                    observationConfig?.CertificationRetryAttemptsTeacher
                  ? "Max Attempt"
                  : "Failed"}
              </div>
              <div className="col">
                {certificationData.Status === 2 ||
                certificationData.Status === 4 ? (
                  <ButtonControl
                    type={"okay"}
                    onClick={() => {
                      if (certificationData.Status !== 4) {
                        updateCertification("BeginPart2");
                      }
                      if (certificationData.Status === 4) {
                        setCurrentPhase(8);
                      } else handleNextPhase();
                      grabCurrentOrNextQuestion();
                      setQuestions(certificationData.Questions);
                    }}
                  >
                    {certificationData.Status === 2 ? "Begin" : "Continue"}
                  </ButtonControl>
                ) : (
                  certificationData.Status === 6 && (
                    <ButtonControl
                      type={"okay"}
                      loading={saving}
                      onClick={async () => {
                        await handleRetake(2);
                      }}
                      disabled={
                        !appUserMgr?.canWrite("Certification") ||
                        ((!observationConfig || userCantRetake(2)) &&
                          certificationData.Status === 6)
                      }
                    >
                      {certificationData.RetakeCount + 1 >=
                      observationConfig?.CertificationRetryAttemptsTeacher
                        ? "Locked"
                        : "Retake"}
                    </ButtonControl>
                  )
                )}
              </div>
            </div>
          </div>
          <div className="double-column-right">
            <h2>History</h2>
            <div className="row-header">
              <div className="col">School Year</div>
              <div className="col">Print Certificate</div>
            </div>
            {_.map(certificationHistory, (x) => {
              return (
                <div className="row">
                  <div className="col">{`${x.SchoolYearIdentifier - 1}-${
                    x.SchoolYearIdentifier
                  }`}</div>
                  <div className="col">
                    <button
                      type="button"
                      className="icon-wrapper"
                      aria-label={`Print ${
                        x.SchoolYearIdentifier - 1
                      }-${x.SchoolYearIdentifier} certificate`}
                      aria-busy={printing === x.Id}
                      disabled={!!printing}
                      onClick={() => {
                        setPrinting(x.Id);
                        Promise.resolve(handleOpenPrint(x, x))
                          .catch((err) =>
                            console.error(
                              "Failed to prepare certificate for printing",
                              err
                            )
                          )
                          .finally(() => setPrinting(null));
                      }}
                    >
                      {printing === x.Id ? (
                        <span aria-hidden="true">
                          <Loading type="default" size="1rem" />
                        </span>
                      ) : (
                        <FontAwesomeIcon
                          className={
                            "fa-icon" + (printing ? " fa-icon-disabled" : "")
                          }
                          icon={faPrint}
                          aria-hidden="true"
                        />
                      )}
                    </button>
                    {printing === x.Id && (
                      <span className="visually-hidden" role="status">
                        {`Preparing ${
                          x.SchoolYearIdentifier - 1
                        }-${x.SchoolYearIdentifier} certificate for printing`}
                      </span>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };

  const renderPhaseTwo = (passed) => {
    if (certificationData.Status === 2 || certificationData.Status === 5) {
      passed = true;
    } else if (
      certificationData.Status === 3 ||
      certificationData.Status === 6
    ) {
      passed = false;
    }

    const retakeDate = new Date(
      Date.now(certificationData.CompletedDate) +
        observationConfig?.DaysUntillRetryTeacherCert * 1000 * 60 * 60 * 24
    );
    let hours = retakeDate.getHours();
    const minutes = retakeDate.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12;
    hours = hours || 12;

    const minutesStr = minutes < 10 ? "0" + minutes : minutes;

    return (
      <div className="certification">
        <div className="phase-two">
          <h1>ONLINE CERTIFICATION</h1>
          <div className="certification-subheader-wrapper">
            <h2> General Knowledge and Case Studies</h2>
            <button
              className="view-rubric-btn"
              onClick={() => setOpenRubricDialog(true)}
            >
              <img src={rubricIcon} alt="" />
              View Rubric
            </button>
          </div>
          <div className="certification-content">
            <figure className="certification-image-wrapper">
              <img
                className="certification-image"
                src={certImg2}
                alt="certImg2"
              />
            </figure>
            <div className="certification-para-wrapper">
              {passed !== undefined ? (
                passed ? (
                  <h3>
                    <img src={checkmark} alt="" /> Exam Result:{" "}
                    <span>Passed</span>
                  </h3>
                ) : (
                  <h3>
                    <img src={failIcon} alt="" /> Exam Result:{" "}
                    <span>Did not meet the requirements</span>
                  </h3>
                )
              ) : (
                <h3>
                  {" "}
                  {certificationData?.Status == 4
                    ? "Step #2: Post-Conference"
                    : "Step #1A: Observe a Lesson"}
                </h3>
              )}
              <p className="certification-para" role={passed !== undefined ? "alert" : undefined}>
                {passed !== undefined
                  ? passed
                    ? certificationData.Status == 2
                      ? 'Congratulations! You have passed Part I of the Teacher Evaluator Certification. Click "Finish" to move on to start Part II.'
                      : "Congratulations! You have passed Part II of the Teacher Evaluator Certification."
                    : "The number of correct questions was not answered to pass this exam. "
                  : certificationData?.Status == 1
                  ? "Please watch the following video of a teacher's lesson and prepare to evaluate it using the rubric provided. You may pause the video at any time, but the entire video must be viewed in order to proceed to the next screen to evaluate the lesson. "
                  : "Please answer the following multiple choice questions in this step. You must view all documents and watch all videos prior to selecting your answer choice. Remember, do NOT use your browser's back arrow button."}
              </p>
              {passed === false && (
                <div className="attempt-text-wrapper">
                  <img src={announcementIcon} alt="" />
                  <p>
                    {(certificationData.Status == 3 &&
                      certificationData.RetakeCountPart1 + 1 >=
                        observationConfig?.CertificationRetryAttemptsTeacherPart1) ||
                    (certificationData.Status == 6 &&
                      certificationData.RetakeCount + 1 >=
                        observationConfig?.CertificationRetryAttemptsTeacher)
                      ? "You have reached the maximum number of attempts for this certification."
                      : `You may retake the exam after ${retakeDate.toLocaleDateString(
                          "en-us"
                        )} at ${hours}:${minutesStr} ${ampm}.`}
                  </p>
                </div>
              )}
              <div className="btn-wrapper">
                {passed !== undefined ? (
                  passed ? (
                    <ButtonControl
                      type={"okay"}
                      onClick={() => {
                        if (certificationData.Status === 2) {
                          handleNextPhase();
                        } else if (certificationData.Status === 5) {
                          setCertificationHistory([
                            ...certificationHistory,
                            certificationData,
                          ]);
                          setCurrentPhase(1);
                        }
                      }}
                    >
                      FINISH
                    </ButtonControl>
                  ) : (
                    <ButtonControl
                      type={"cancel"}
                      onClick={() => {
                        setCurrentPhase(1);
                      }}
                    >
                      RETURN
                    </ButtonControl>
                  )
                ) : (
                  <ButtonControl type={"okay"} onClick={handleNextPhase}>
                    START
                  </ButtonControl>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const [pauseVideo, setPauseVideo] = useState(false);
  const [isNavigatingAway, setIsNavigatingAway] = useState(false);

  const handlePauseVideoAndSave = () => {
    console.log('handlePauseVideoAndSave called');
    // Set navigating away flag to prevent new player creation
    setIsNavigatingAway(true);
    
    // Force immediate destruction first to prevent multiple players
    if (bitmovinPlayerRef.current) {
      console.log('Player ref found, attempting destruction');
      try {
        const player = bitmovinPlayerRef.current.getPlayer();
        if (player) {
          // Try to get current time before destroying
          try {
            const newTime = bitmovinPlayerRef.current.getCurrentTime();
            setCurrentTime(newTime);
            updateCertification("UpdateRubricVideoTimeStamp", newTime);
          } catch (timeError) {
            console.warn('Could not get current time:', timeError.message);
          }
          
          // Force immediate destruction
          player.destroy();
          console.log('Player force destroyed in handlePauseVideoAndSave');
        } else {
          console.log('No player instance found');
        }
      } catch (error) {
        console.warn('Force player destruction error:', error.message);
      } finally {
        // Clear the ref immediately to prevent reuse
        bitmovinPlayerRef.current = null;
        console.log('Player ref cleared');
      }
    } else {
      console.log('No player ref found');
    }
    
    // Small delay to ensure state update before navigation
    setTimeout(() => {
      navigate("/certifications/teacher");
    }, 100);
  };

  const memoizedBitmovinVideo = useMemo(() => {
    //console.log('memoizedBitmovinVideo recreating...', certificationData?.Content?.File);

    // Don't render player if navigating away
    if (isNavigatingAway) {
      console.log('Player prevented from rendering - navigating away');
      return null;
    }

    const handleVideoEnded = () => {
      updateCertification("FinishedRubricVideo");
    };

    const handleVideoPause = (currentTime) => {
      setCurrentTime(currentTime);
    };

    return (
      <div className="video-player">
        <div id="player-wrapper">
          <BitmovinPlayer
            key="certification-main-video"
            ref={bitmovinPlayerRef}
            content={certificationData?.Content?.File}
            onEnded={handleVideoEnded}
            onPause={handleVideoPause}
            startAtEnd={certificationData?.CurrentVideoTimeStamp === "FINISHED"}
            currentTimeStamp={certificationData?.CurrentVideoTimeStamp === "FINISHED" ? 0 : parseInt(certificationData?.CurrentVideoTimeStamp ?? 0)}
            autoplay={false}
            mediaTitle={`Certification observation video: ${certificationData?.Content?.DisplayFileName ?? "lesson video"}`}
            onReturn={handlePauseVideoAndSave}
            returnLabel="Save & Continue Later"
          />
        </div>
      </div>
    );
  }, [certificationData?.Content?.File, certificationData?.CurrentVideoTimeStamp, isNavigatingAway]);

  const onUnMountRubricVideo = (currentTime) => {
    if (
      certificationData.CurrentVideoTimeStamp !== "FINISHED" &&
      currentTime !== 0
    ) {
      updateCertification("UpdateRubricVideoTimeStamp", currentTime);
    }
  };

  const onBitmovinPlayer = () => {
    setUseBitmovinPlayer(!useBitmovinPlayer);
  };

  const renderPhaseThree = () => {
    return (
      <div className="phase-three">
        <div
          className={"video-section"}
          style={
            isSnappedLeft
              ? { width: "40%" }
              : isSnappedRight
              ? { width: `calc(100% - calc(16px + ${FIXED_ROW_WIDTH}))` }
              : {
                  width: `${leftWidth}%`,
                  maxWidth: `calc(100% - calc(16px + ${FIXED_ROW_WIDTH}))`,
                }
          }
        >
          <h1>ONLINE CERTIFICATION</h1>
          <div className="phase-three-subheader">
            <div className="left">
              <h2>Step #1A: Observe a Lesson</h2>

              {/* Make dynamic later */}
              <p>Video: {certificationData?.Content?.DisplayFileName}</p>
            </div>
            <div className="right">
              <div className="button-wrapper">
                <ButtonControl
                  type={"okay"}
                  loading={saving}
                  onClick={() => {
                    handlePauseVideoAndSave();
                  }}
                >
                  SAVE & CONTINUE LATER
                </ButtonControl>
                <ButtonControl
                  disabled={!watchedRubricVideo}
                  type={"okay"}
                  loading={
                    saving &&
                    certificationData.CurrentVideoTimeStamp === "FINISHED"
                  }
                  onClick={() => {
                    updateCertification("NextBtnRubric").then(() => {
                      if (!saving) {
                        handleNextPhase();
                      }
                    });
                  }}
                >
                  NEXT
                </ButtonControl>
              </div>
              <span>
                <em>Entire video must be watched to proceed.</em>
              </span>
            </div>
          </div>
          <div className="video-wrapper">{memoizedBitmovinVideo}</div>
        </div>
        <div
          className={`rubric-section`}
          style={
            isSnappedRight
              ? { width: `calc(${FIXED_ROW_WIDTH} + 16px)` }
              : isSnappedLeft
              ? { width: "60%" }
              : { width: `${100 - leftWidth}%` }
          }
        >
          <div
            className={`drag-me`}
            role="separator"
            aria-orientation="vertical"
            aria-label="Resize video and rubric panels"
            aria-describedby="split-view-instructions"
            aria-valuenow={Math.round(getSplitViewValue())}
            aria-valuemin={SPLIT_MIN_PERCENT}
            aria-valuemax={SPLIT_MAX_PERCENT}
            tabIndex={0}
            onMouseDown={mouseDownHandler}
            onFocus={handleSeparatorFocus}
            onKeyDown={handleSeparatorKeyDown}
            onDoubleClick={(e) => {
              let isLeft = isSnappedLeft;
              let isRight = isSnappedRight;

              if (isLeft || isRight) {
                setIsSnappedLeft(!isLeft);
                setIsSnappedRight(isLeft);
              } else {
                if (e.pageX < (1.6 * document.body.clientWidth) / 2) {
                  setIsSnappedRight(true);
                } else {
                  setIsSnappedLeft(true);
                }
              }
            }}
          >
            <FontAwesomeIcon
              icon={faEllipsisVertical}
              className={"person-icon"}
              aria-hidden="true"
            />
          </div>
          <span id="split-view-instructions" className="visually-hidden">
            Use the left and right arrow keys to resize the video and rubric
            panels. Press Home for a rubric-priority layout, End for a
            video-priority layout, and Escape to cancel a resize.
          </span>
          <div className={`content-area`}>
            {loadingRubric ? (
              <div className="loading-wrapper">
                <Loading type="default" size="5rem" />{" "}
              </div>
            ) : (
              <SurveyTable
                isSelfReflection={true}
                disableActOfRating={true}
                gridData={gridData}
                fixedRowWidth={FIXED_ROW_WIDTH}
                hideRatingBtn={true}
                hideIndicatorsProgress={true}
              />
            )}
          </div>
        </div>
      </div>
    );
  };
  const renderPhaseFour = () => {
    return (
      <div className="phase-four">
        <div className="container">
          <h1>ONLINE CERTIFICATION</h1>
          <div className="phase-three-subheader">
            <div className="left">
              <h2>Step #1B: Rate the Lesson</h2>
              <p>Video: {certificationData?.Content?.DisplayFileName}</p>
            </div>

          </div>
          <div
            className={"rubric-wrapper" + (loadingRubric ? " no-borders" : "")}
          >
            {loadingRubric ? (
              <Loading type="default" size="5rem" />
            ) : (
              <SurveyTable
                isSelfReflection={true}
                ratingSelectOptions={ratingSelectOptions}
                indicatorsRated={indicatorsRated}
                gridData={gridData}
                fixedRowWidth={FIXED_ROW_WIDTH}
                toggleRatingOptions={toggleRatingOptions}
                selectRating={selectRating}
              />
            )}
          </div>
          <div className="phase-four-finish">
            <ButtonControl
              type={"okay"}
              disabled={
                !_.every(ratingSelectOptions, "selectedRating") ||
                loadingRubric
              }
              loading={saving}
              onClick={async () => {
                await updateCertification("FinishRubricRatings");
                handleNextPhase();
              }}
            >
              Finish
            </ButtonControl>
            <span>
              <em>All rubric items must be rated to proceed.</em>
            </span>
          </div>
        </div>
      </div>
    );
  };

  const memoizedBitmovinQuestionVideo = useMemo(() => {
    return (
      <div className="video-player">
        <div id="player-wrapper">
          <BitmovinPlayer
            ref={questionPlayerRef}
            content={currentQuestion?.File}
            onEnded={() => {
              setWatchedQuestionVideo(true);
            }}
            currentTimeStamp={0}
            autoplay={false}
            mediaTitle={`Video for Question ${currentQuestion?.number ?? ""}`}
          />
        </div>
      </div>
    );
  }, [currentQuestion?.File, currentQuestion?.number]);

  const isFinalQuestion =
    _.countBy(questions, (question) => question.SelectedAnswer !== null).true ===
    questions?.length - 1;
  const handleQuestionContinue = async () => {
    focusNextQuestionRef.current = !isFinalQuestion;
    grabCurrentOrNextQuestion();
    setWatchedQuestionVideo(false);
    const result = await saveQuestion();
    if (isFinalQuestion && result) {
      await updateCertification("FinishQuestions");
      handleNextPhase();
    }
  };

  const renderPhaseFive = () => {
    return (
      <div className="certification">
        <div className="certification-header-wrapper">
          <h1>ONLINE CERTIFICATION</h1>
          <span className="current-total-question">{`${
            currentQuestion.number - 1
          } questions completed / ${questions.length} total`}</span>
        </div>
        {/* Make dynamic */}
        <div
          className={
            "certification-question-wrapper" +
            (currentQuestion.hasFile ? " two-columns" : "")
          }
        >
          <div>
            <h2>Question #{currentQuestion.number}</h2>
            <div
              dangerouslySetInnerHTML={{
                __html: currentQuestion.QuestionText.replace(/\n/g, "<br />"),
              }}
            />
          </div>
          {currentQuestion.hasFile && (
            <div className="file-wrapper">
              {checkIsVideo(currentQuestion.FileUrl) ? (
                <>
                  <div
                    className="question-video-resource"
                    role="region"
                    aria-label={`Video for Question ${currentQuestion.number}`}
                    tabIndex={0}
                  >
                    {memoizedBitmovinQuestionVideo}
                  </div>
                  <button
                    type="button"
                    className="view-file question-resource-button"
                    aria-label={`Play Video for Question ${currentQuestion.number}`}
                    onClick={() => questionPlayerRef.current?.play()}
                  >
                    Play Video
                  </button>
                </>
              ) : (
                <>
                  <button
                    type="button"
                    className="view-file question-resource-button"
                    aria-label={`${openPdfViewer ? "Close" : "View"} Document for Question ${currentQuestion.number}`}
                    aria-expanded={openPdfViewer}
                    onClick={() => {
                      setWatchedQuestionVideo(true);
                      setOpenPdfViewer(!openPdfViewer);
                    }}
                  >
                    <img className="file-img" src={documentIcon} alt="" aria-hidden="true" />
                    <span>{openPdfViewer ? "Close" : "View"} Document</span>
                  </button>
                  {openPdfViewer && (
                    <FloatingPdfFileViewer
                      fileUrl={currentQuestion.FileUrl}
                      onClose={() => setOpenPdfViewer(false)}
                    />
                  )}
                </>
              )}
            </div>
          )}
        </div>
        <fieldset className="certification-answer-wrapper" ref={answerGroupRef} tabIndex={-1}>
          <legend>Answers for Question {currentQuestion.number}</legend>
          <div className="answer-options-wrapper">
            <div className="answer-options">
              <div className="option">Select</div>
              <div className="option">Answer</div>
              <div className="option">Description</div>
              {_.some(currentQuestion.Answers, (x) => x.FileId) && (
                <div className="option-video">Video/Document</div>
              )}
            </div>
            {_.map(currentQuestion.Answers, (x, i) => (
              <div className="answer-options" key={i}>
                <div className="option">
                  <input
                    id={`teacher-question-${currentQuestion.Id}-answer-${x.Id}`}
                    name={`teacher-question-${currentQuestion.Id}`}
                    aria-label={`Answer ${String.fromCharCode(65 + i)}`}
                    disabled={!watchedQuestionVideo && currentQuestion.FileUrl}
                    onChange={() => updateQuestionAnswer(x.Id)}
                    checked={currentQuestion.SelectedAnswer === x.Id}
                    type="radio"
                  />
                </div>
                <div className="option">{String.fromCharCode(65 + i)}</div>
                <div className="option">
                  <ReactQuill
                    readOnly={true}
                    theme="bubble"
                    value={x.AnswerText}
                    className="rq"
                  />
                </div>
                {x.FileId && x.File && (
                  <div className="option-video">
                    {checkIsVideo(x.File.FileUrl) ? (
                      <button
                        type="button"
                        className="answer-resource-button"
                        aria-label={`Watch video for Answer ${String.fromCharCode(65 + i)}`}
                        onClick={() => {
                          setAnswerVideo(x?.File);
                          setOpenAnswerFileDialog(
                            `Answer Choice ${String.fromCharCode(65 + i)}`
                          );
                        }}
                      >
                        <img src={videoIcon} alt="" aria-hidden="true" />
                      </button>
                    ) : (
                      <a
                        className="answer-resource-button"
                        href={x.File.FileUrl}
                        download={"file"}
                        aria-label={`Download document for Answer ${String.fromCharCode(65 + i)}`}
                      >
                        <img
                          className="document-icon"
                          src={documentIcon}
                          alt=""
                          aria-hidden="true"
                        />
                      </a>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        </fieldset>
        <div className="btn-wrapper">
          <ButtonControl
            loading={saving}
            disabled={!currentQuestion.SelectedAnswer || !currentQuestion}
            type="okay"
            onClick={() => handleQuestionContinue()}
          >
            {_.countBy(
              questions,
              (question) => question.SelectedAnswer !== null
            ).true ===
            questions.length - 1
              ? "FINISH"
              : "NEXT"}
          </ButtonControl>
        </div>
      </div>
    );
  };

  const memoizedBitmovinAnswerVideo = useMemo(() => {
    return (
      <div className="video-player">
        <div id="player-wrapper">
          <BitmovinPlayer
            content={answerVideo}
            currentTimeStamp={0}
            autoplay={false}
            mediaTitle={`${openAnswerFileDialog || "Answer choice"} video`}
          />
        </div>
      </div>
    );
  }, [answerVideo, openAnswerFileDialog]);

  return (
    <>
      {openAnswerFileDialog && (
        <DialogControl
          title={openAnswerFileDialog}
          openDialog={openAnswerFileDialog}
          excludeCancel={true}
          onCancel={() => setOpenAnswerFileDialog(false)}
        >
          <>{memoizedBitmovinAnswerVideo}</>
        </DialogControl>
      )}
      {openRubricDialog && renderRubricModal()}
      <div className="certification-flow">
        {currentPhase === 1 && renderPhaseOne()}
        {currentPhase === 2 && renderPhaseTwo()}
        {currentPhase === 3 && renderPhaseThree()}
        {currentPhase === 4 && renderPhaseFour()}
        {currentPhase === 5 && renderPhaseTwo(certificationData)}
        {currentPhase === 6 && renderPhaseOne()}
        {currentPhase === 7 && renderPhaseTwo()}
        {currentPhase === 8 && renderPhaseFive()}
        {currentPhase === 9 && renderPhaseTwo(certificationData)}
        <CertificationProgress
          certificationType="Teacher Evaluator"
          steps={teacherCertificationSteps}
          activeStep={teacherPhaseToStep[currentPhase]}
          helpUrl="/downloads/Teacher Evaluator Certification User Guide_12.4.25.pdf"
        />
      </div>
    </>
  );
};

export default CertificationTeacherDetails;
